import { render, staticRenderFns } from "./relatedDelete.vue?vue&type=template&id=b5a578b8"
import script from "./relatedDelete.vue?vue&type=script&lang=js"
export * from "./relatedDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports